import { render, staticRenderFns } from "./RequiredAsterisk.vue?vue&type=template&id=7962247c&"
import script from "./RequiredAsterisk.vue?vue&type=script&lang=ts&"
export * from "./RequiredAsterisk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports